import React from "react";

const ProductsMain = () => {
  return <div>ProductsMain</div>;
};

export default ProductsMain;
